import React from 'react';
import { Box } from '@mui/material';

import Block from './Block';

import TextBlockView from './TextBlockView';
import ImageBlockView from './ImageBlockView';
import YoutubeBlockView from './YoutubeBlockView';
import VideoBlockView from './VideoBlockView';
import PDFBlockView from './PDFBlockView';

import TextBlockEditView from './TextBlockEditView';
import ImageBlockEditView from './ImageBlockEditView';
import YoutubeBlockEditView from './YoutubeBlockEditView';
import VideoBlockEditView from './VideoBlockEditView';
import PDFBlockEditView from './PDFBlockEditView';

function BlockListView({backgroundColor, blocks, onBlockUpdate}) {
	const BLOCKMODE_VIEWING = 0;
	const BLOCKMODE_EDITING = 1;

	const [curBlocks,/*setCurBlocks*/] = React.useState(blocks);
	const [blockModes,setBlockModes] = React.useState(blocks.map(e => BLOCKMODE_VIEWING));

	const handleEditRequested = (block) => {
		console.log("handleEditRequested: blockName = " + block.name);

		let newBlockModes = [];

		for (let i = 0; i < curBlocks.length; i++) {
			if (curBlocks[i].name === block.name) {
				// blockModes[i] must be BLOCKMODE_VIEWING
				newBlockModes[i] = BLOCKMODE_EDITING;
			}
			else {
				newBlockModes[i] = blockModes[i];
			}
		}
		setBlockModes(newBlockModes);
	};

	const handleEditDone = (block) => {
		console.log("handleEditDone: blockName = " + block.name);

		let newBlockModes = [];

		for (let i = 0; i < blocks.length; i++) {
			if (blocks[i].name === block.name) {
				// blockModes[i] must be BLOCKMODE_EDITING
				newBlockModes[i] = BLOCKMODE_VIEWING;
			}
			else {
				newBlockModes[i] = blockModes[i];
			}
		}
		setBlockModes(newBlockModes);

		if (onBlockUpdate) {
			onBlockUpdate(block);
		}
	};

	const handleEditCancel = (block) => {
		console.log("handleEditCancel: blockName = " + block.name);

		let newBlockModes = [];

		for (let i = 0; i < curBlocks.length; i++) {
			if (curBlocks[i].name === block.name) {
				// blockModes[i] must be BLOCKMODE_EDITING
				newBlockModes[i] = BLOCKMODE_VIEWING;
			}
			else {
				newBlockModes[i] = blockModes[i];
			}
		}
		setBlockModes(newBlockModes);
	};

	function getBlockView(blockType, blockMode, block, idx) {
        const iconColors = [
            'orange',
            'purple',
        ];

        let iconChar = String.fromCharCode('A'.charCodeAt(0) + idx);
        let iconColor = iconColors[idx % iconColors.length];

		if (blockType === Block.TYPE_TEXT) {
			if (blockMode === BLOCKMODE_EDITING) {
				return (
					<TextBlockEditView
						key={block.name}
						idx={idx}
						iconChar={iconChar}
						iconColor={iconColor}
						block={block}
						onDone={handleEditDone}
						onCancel={handleEditCancel}
					/>
				);
			}
			else {	// blockType === BLOCKMODE_VIEWING
				return (
					<TextBlockView
						key={block.name}
						idx={idx}
						block={block}
						allowEditing={onBlockUpdate !== undefined}
						onEdit={handleEditRequested}
					/>
				);
			}
		}
		else if (blockType === Block.TYPE_IMAGE) {
			if (blockMode === BLOCKMODE_EDITING) {
				return (
					<ImageBlockEditView
						key={block.name}
						idx={idx}
						iconChar={iconChar}
						iconColor={iconColor}
						block={block}
						onDone={handleEditDone}
						onCancel={handleEditCancel}
					/>
				);
			}
			else {	// blockType === BLOCKMODE_VIEWING
				return (
					<ImageBlockView
						key={block.name}
						idx={idx}
						block={block}
						allowEditing={onBlockUpdate !== undefined}
						onEdit={handleEditRequested}
					/>
				);
			}
		}
		else if (blockType === Block.TYPE_YOUTUBE) {
			if (blockMode === BLOCKMODE_EDITING) {
				return (
					<YoutubeBlockEditView
						key={block.name}
						idx={idx}
						iconChar={iconChar}
						iconColor={iconColor}
						block={block}
						onDone={handleEditDone}
						onCancel={handleEditCancel}
					/>
				);
			}
			else {	// blockType === BLOCKMODE_VIEWING
				return (
					<YoutubeBlockView
						key={block.name}
						idx={idx}
						block={block}
						allowEditing={onBlockUpdate !== undefined}
						onEdit={handleEditRequested}
					/>
				);
			}
		}
		else if (blockType === Block.TYPE_VIDEO) {
			if (blockMode === BLOCKMODE_EDITING) {
				return (
					<VideoBlockEditView
						key={block.name}
						idx={idx}
						iconChar={iconChar}
						iconColor={iconColor}
						block={block}
						onDone={handleEditDone}
						onCancel={handleEditCancel}
					/>
				);
			}
			else {	// blockType === BLOCKMODE_VIEWING
				return (
					<VideoBlockView
						key={block.name}
						idx={idx}
						block={block}
						allowEditing={onBlockUpdate !== undefined}
						onEdit={handleEditRequested}
					/>
				);
			}
		}
		else if (blockType === Block.TYPE_PDF) {
			if (blockMode === BLOCKMODE_EDITING) {
				return (
					<PDFBlockEditView
						key={block.name}
						idx={idx}
						iconChar={iconChar}
						iconColor={iconColor}
						block={block}
						onDone={handleEditDone}
						onCancel={handleEditCancel}
					/>
				);
			}
			else {	// blockType === BLOCKMODE_VIEWING
				return (
					<PDFBlockView
						key={block.name}
						idx={idx}
						block={block}
						allowEditing={onBlockUpdate !== undefined}
						onEdit={handleEditRequested}
					/>
				);
			}
		}
	}

	function getBlockViews() {
		let blockViews = [];

		for (let i = 0; i < blocks.length; i++) {
			let blockView = getBlockView(blocks[i].type, blockModes[i], blocks[i], i);
			if (blockView) blockViews.push(blockView);
		}
		return blockViews;
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				bgcolor: !backgroundColor ? 'white' : backgroundColor,
				position:"relative"
			}}
		>
			{getBlockViews()}
		</Box>
	);
}

export default BlockListView;
